import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import ProductsPage from '../routes/admin/ProductsPage';

export default function AddProductToPlanograma(props) {
    const { open, onClose } = props;

    const installerId = zibi.user.installerId;

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-descriptionx"
        >
            <ProductsPage
                installer={{ _id: installerId }}
                onSelect={product => props.onSelect(product)}
            />
        </Dialog>)
}